module.exports = __webpack_public_path__ + "static/media/30x30-2.58787f2a.png";